import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

const SLayout = styled(Link)`
    color: blue;
`;

const CustomLink = ({
    children,
    className,
    style = {},
    to = '#',
    onClick = () => null,
    isChangeColor,
    isStopJumping,
    stopChangeColor,
}) => {
    const [color, setColor] = useState({});
    const handleClick = (e) => {
        onClick();
        if (isChangeColor && JSON.stringify(color) === "{}" && !stopChangeColor) {
            setColor({ color: 'purple' });
        };
        if (isStopJumping) {
            e.preventDefault();
        };
    };

    return (
        <SLayout className={className} to={to} style={{ ...style, ...color }} onClick={e => handleClick(e)}>
            {children}
        </SLayout>
    );
};

export default CustomLink;
